import { isSingleChat } from './ChatHelper';
import { REACT_APP_CONTACT_SYNC, REACT_APP_XMPP_SOCKET_HOST } from '../../Components/processENV';
import { CHAT_TYPE_SINGLE, CHAT_TYPE_GROUP } from './Constant';
import { getFormatPhoneNumber, getMentionNameFromRoaster } from '../Utility';
import Store from '../../Store';
import { addNewRosterAction } from '../../Actions/RosterActions';
import { get as _get } from 'lodash';
import SDK from '../../Components/SDK';
const requestUserids = [];

export const formatUserIdToJid = (userId, chatType = CHAT_TYPE_SINGLE) => {
    if (!userId || userId.includes(`${REACT_APP_XMPP_SOCKET_HOST}`)) return userId;
    return isSingleChat(chatType)
        ? `${userId}@${REACT_APP_XMPP_SOCKET_HOST}`
        : `${userId}@mix.${REACT_APP_XMPP_SOCKET_HOST}`;
};

export const formatGroupIdToJid = groupId => {
    if (!groupId || groupId.includes(`mix.${REACT_APP_XMPP_SOCKET_HOST}`)) return groupId;
    return formatUserIdToJid(groupId, CHAT_TYPE_GROUP);
};

export const isSingleChatJID = jid => {
    return !jid.includes('mix');
};

/**
 * Return the ID(userId or groupId) from given jid(userJid or groupdJid)
 * @param {*} jid
 */
export const getIdFromJid = jid => {
    if (!jid) return jid;
    return jid.split('@')[0];
};

/**
 * Return the user Id from given message object based on the chat type
 * Onetoone chat userId will contain by fromUserId
 * Group chat userId will contain by publisherId
 * @param {*} msgObj
 */
export const getSenderIdFromMsgObj = msgObj => {
    if (!msgObj || typeof msgObj != 'object') return '';
    const { fromUserId, publisherId } = msgObj;
    return isSingleChat(msgObj.chatType) ? fromUserId : publisherId;
};

export const getGroupNameFromRoster = roster => {
    if (!roster || typeof roster != 'object') return roster;
    return roster.groupName || roster.groupId;
};

export const getContactNameFromRoster = (
    roster,
    { ignoreFriendAndDeletedCheck = false, decorateNonFriend = false } = {},
) => {
    if (!roster || typeof roster !== 'object') return roster;

    if (roster.groupId) {
        return getGroupNameFromRoster(roster);
    }

    let name;

    if (!REACT_APP_CONTACT_SYNC) {
        name = roster.nickName || getFormatPhoneNumber(roster.mobileNumber) || roster.name || roster.userId;
    } else {
        if (!ignoreFriendAndDeletedCheck && !roster.isFriend && !roster.isDeletedUser) {
            name = getFormatPhoneNumber(roster.userId);
        } else {
            name = roster.name || roster.nickName || getFormatPhoneNumber(roster.mobileNumber) || roster.userId;
        }
    }

    if (decorateNonFriend && !roster.isFriend) {
        name = `~${name}`;
    }

    return name;
};

export const initialNameHandle = (roster = {}) => {
    if (isLocalUser(roster.fromUser)) return getMentionNameFromRoaster(roster);
    const contactsWhoBlockedMe = Store.getState().contactsWhoBlockedMe.data;
    if (
        !roster.isAdminBlocked &&
        !roster.isDeletedUser &&
        !contactsWhoBlockedMe.indexOf(formatUserIdToJid(roster.userId)) > -1
    ) {
        return getMentionNameFromRoaster(roster);
    }
    return '';
};

export const arrayRoasterinitialNameHandle = (roster = [], name = '') => {
    roster.forEach(ele => {
        if (_get(ele, 'isFriend', false) !== false || _get(ele, 'image', '') !== '') {
            return name;
        }
        return '';
    });
};

export const getUserInfoForSearch = roster => {
    if (!roster || typeof roster != 'object') return roster;
    let fieldsForSearch = [];
    if (!REACT_APP_CONTACT_SYNC) {
        fieldsForSearch = ['nickName', 'groupName'];
    } else {
        fieldsForSearch = ['name', 'groupName'];
        if (!roster.isFriend) {
            fieldsForSearch.push('userId');
        }
    }
    const userInfo = [];
    fieldsForSearch.forEach(field => roster[field] && userInfo.push(roster[field]));
    return userInfo;
};

/**
 * Check the given user is local or not
 * @param {*} userId
 */
export const isLocalUser = (userId = '') => {
    if (!userId) return false;
    userId = getIdFromJid(userId);
    const vCardData = Store.getState().vCardData;
    return userId === vCardData?.data?.fromUser;
};

export const getLocalUserDetails = () => {
    const vCardData = Store.getState().vCardData;
    return vCardData?.data;
};

export const getDataFromRoster = userId => {
    if (isLocalUser(userId)) {
        const vCardData = Store.getState().vCardData;
        return vCardData?.data;
    }
    const currentState = Store.getState();
    let {
        rosterData: { rosterNames },
    } = currentState;
    if (rosterNames instanceof Map) {
        if (!rosterNames?.has(userId)) {
            if (userId) {
                getDataFromSDK(userId);
            }
            let data = { userId: userId, userJid: formatUserIdToJid(userId) };
            return data;
        } else {
            return rosterNames.get(userId);
        }
    }
    return {};
};

export const getDataFromSDK = async userId => {
    let data = { userId: userId, userJid: formatUserIdToJid(userId) };
    if (!requestUserids.includes(userId)) {
        requestUserids.push(userId);
        const profileDetailsResponse = await SDK.getUserProfile(formatUserIdToJid(userId));
        let index = requestUserids.indexOf(userId);
        if (index !== -1) {
            requestUserids.splice(index, 1);
        }
        if (profileDetailsResponse.statusCode === 200) {
            let userProfileDetails = profileDetailsResponse.data;
            userProfileDetails.name = userProfileDetails.nickName;
            userProfileDetails.userId = userId;
            data = {
                ...data,
                ...userProfileDetails,
            };
            addVcardDataToRoster(data);
        } else if (profileDetailsResponse.statusCode === 204) {

            data = {
                ...data,
                isDeletedUser: true,
                email: '',
                image: '',
                thumbImage: '',
                isAdminBlocked: false,
                isFriend: false,
                mobileNumber: '',
                name: 'Deleted User',
                nickName: 'Deleted User',
                displayName: 'Deleted User',
                status: '',
            };
            addVcardDataToRoster(data);
        } else {

            const formattedNumber = getFormatPhoneNumber(userId) || userId;
            data = {
                ...data,
                isDeletedUser: false,
                email: '',
                image: '',
                thumbImage: '',
                isAdminBlocked: false,
                isFriend: false,
                mobileNumber: '',
                name: formattedNumber,
                nickName: formattedNumber,
                displayName: formattedNumber,
                status: '',
            };
            addVcardDataToRoster(data);
        }
    }
    return data;
};

export const isUserExistInRoster = userId => {
    const currentState = Store.getState();
    const {
        rosterData: { rosterNames },
    } = currentState;
    return !!rosterNames?.has(userId);
};

export const formatDisplayName = (messageFrom = '') => {
    const userPhoneNumber = messageFrom.split('@')[0];
    const rosterObject = getDataFromRoster(messageFrom);
    if (!rosterObject) {
        return {
            nameToDisplay: getFormatPhoneNumber(userPhoneNumber),
            userColor: 'black',
        };
    }
    const { userColor } = rosterObject || {};
    const nameToDisplay = getContactNameFromRoster(rosterObject);
    return {
        nameToDisplay,
        userColor,
    };
};

export const addVcardDataToRoster = userObj => {
    if (!userObj || typeof userObj !== 'object') return;
    if (userObj.userId && !userObj.userJid) {
        userObj['userJid'] = formatUserIdToJid(userObj.userId);
    }
    Store.dispatch(addNewRosterAction({ ...userObj, isFriend: false }));
};

export const getUserNickName = userObj => {
    return userObj?.nickName || userObj?.userProfile?.nickName;
};

export const isDisplayNickName = userObj => {
    return !isLocalUser(userObj.userId) && !userObj.isFriend && userObj.nickName;
};

export const getFriendsFromRosters = rosters => {
    if (!rosters || !Array.isArray(rosters)) return rosters;
    return rosters.filter(user => user.isFriend);
};
export const getUserDetailsForMention = (userJid = '') => {
    let rosterData = {};
    let user = userJid.includes('@') ? userJid.split('@')[0] : userJid;
    let userDetails = getDataFromRoster(user);
    if (Object.keys(userDetails).length > 0) {
        rosterData.displayName = userDetails?.name;
    } else {
        rosterData.displayName = getFormatPhoneNumber(user);
    }
    return rosterData;
};

export const getUserDetails = (userJid = '') => {
    userJid = userJid || '';
    let rosterData = {};
    let user = userJid.includes('@') ? userJid.split('@')[0] : userJid;
    let vcardData = getLocalUserDetails() || {};
    if (user === vcardData?.fromUser) {
        rosterData.displayName = 'You';
        rosterData.isFriend = true;
        rosterData.image = vcardData.image;
        rosterData.thumbImage = vcardData.thumbImage;
        rosterData.jid = user;
        rosterData.chatType = 'chat';
        rosterData.initialName = vcardData.nickName;
    } else {
        let userDetails = getDataFromRoster(user);
        let { isAdminBlocked, image, thumbImage } = userDetails;
        if (Object.keys(userDetails).length > 0) {
            rosterData = userDetails;
            rosterData.displayName = getContactNameFromRoster(userDetails);
            rosterData.image = isAdminBlocked ? '' : image;
            rosterData.thumbImage = isAdminBlocked ? '' : thumbImage;
            rosterData.chatType = 'chat';
            rosterData.initialName = isAdminBlocked ? '' : rosterData.displayName;
            rosterData.isAdminBlocked = isAdminBlocked;
        } else {
            rosterData.displayName = getFormatPhoneNumber(user);
            rosterData.initialName = '';
            rosterData.image = '';
            rosterData.thumbImage = '';
            rosterData.jid = user;
            rosterData.chatType = 'chat';
            rosterData.userColor = '';
            rosterData.userId = user;
            rosterData.userJid = formatUserIdToJid(user);
            rosterData.isAdminBlocked = isAdminBlocked;
        }
    }
    return rosterData;
};

export const getLocalUserId = () => {
    let vcardData = getLocalUserDetails();
    if (vcardData && Object.keys(vcardData).length) return vcardData.fromUser;
    return '';
};

export const handleMentionedUser = ({
    text,
    mentionedUsersIds,
    mentionedMe,
    mentionedClass = '',
    chatType = 'chat',
}) => {
    let userId = mentionedUsersIds;
    let vcardData = getLocalUserDetails();

    if (!text) return '';

    const pattern = /@\[\?\]/gi;

    if (
        mentionedUsersIds !== undefined &&
        text !== '' &&
        text.match(pattern) !== null &&
        text.match(pattern).length > 0 &&
        text.match(pattern) !== undefined
    ) {
        let content = text;
        let participantData = content.match(pattern);

        participantData.forEach(uidPattern => {
            for (let [i] of userId.entries()) {
                const mentionedUserId = userId[i];
                let rosterData = getUserDetailsForMention(mentionedUserId);
                let displayName = getMentionNameFromRoaster(rosterData);

                // ✅ If mentioned userId matches vcard userId, display "You"
                if (vcardData && vcardData.userId === mentionedUserId) {
                    displayName = getMentionNameFromRoaster(vcardData) || 'You';
                }

                // ✅ Fallback if displayName missing
                if (!displayName) {
                    displayName = mentionedUserId;
                }

                // ✅ Replace the mention in content
                if (chatType === 'groupchat') {
                    content = content.replace(
                        uidPattern,
                        `<button data-mentioned="${mentionedUserId}" class='${mentionedClass}${
                            mentionedMe === mentionedUserId ? ' tagged' : ''
                        } mentioned pointer'>
              <b>@</b> <i class='pointer' style='text-transform: capitalize'>${displayName}</i>
            </button>`,
                    );
                } else if (chatType === 'chat') {
                    content = content.replace(
                        uidPattern,
                        `<b>@</b> <i style='text-transform: capitalize'>${displayName}</i>`,
                    );
                } else {
                    content = content.replace(uidPattern, `@${displayName} `);
                }
            }
        });
        return content;
    } else {
        // 🧩 Handle already rendered mentions
        let parser = new DOMParser();
        let doc = parser.parseFromString(text, 'text/html');
        let spans = doc.querySelectorAll('span');

        spans.forEach(function (span) {
            if (chatType === 'groupchat') {
                if (!span.classList.contains('blue')) {
                    span.classList.add('blue');
                }
                if (span.getAttribute('data-mentioned') === mentionedMe) {
                    if (!span.classList.contains('tagged')) {
                        span.classList.add('tagged');
                    }
                }
            } else {
                span.className = '';
            }
        });

        return doc.body.innerHTML;
    }
};

export function formatUserPhoneNumber(rawNumber) {
    if (!rawNumber) return '';
    const digits = rawNumber.replace(/\D/g, '');
    const local = digits.slice(-10);
    const countryCode = digits.slice(0, digits.length - 10);
    return `+${countryCode} ${local}`;
}
